
import lang from 'dojo/_base/lang';
import dojoQuery from 'dojo/query';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DocumentsEditorForm.html?raw';
import _StatefulSection from '../../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import SearchSelect from '../../../../../moreCore/UI/SearchSelect/SearchSelect';
import Edit from '../../../../../moreCore/UI/Edit/Edit';
import DateInput from '../../../../../moreCore/UI/DateInput/DateInput';
import HintBox from '../../../../../moreCore/UI/HintBox/HintBox';
import _GlobalSelectEntityDialogsMixin from '../../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import MultiLangEdit from '../../../../../moreCore/UI/MultiLangEdit/MultiLangEdit';
class DocumentsEditorForm extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    className: string;
    addressId: string;

    input_PersonalDocNumber: MdsLax<InstanceType<typeof Edit>>;
    input_IssuedAuthority: MdsLax<InstanceType<typeof MultiLangEdit<any>>>;

    input_DocumentType: MdsLax<InstanceType<typeof SearchSelect>>;
    input_AddressDocumentStatus: MdsLax<InstanceType<typeof SearchSelect>>;
    input_IssuedCountry: MdsLax<InstanceType<typeof SearchSelect>>;
    input_IssuedCountry2: MdsLax<InstanceType<typeof SearchSelect>>;

    input_ValidUntil: MdsLax<InstanceType<typeof DateInput>>;
    input_DateMonthYear: MdsLax<InstanceType<typeof DateInput>>;

    input_Owner2: MdsLax<InstanceType<typeof HintBox>>;

    input_InPassport: MdsLax<InstanceType<typeof SearchSelect>>;
    input_PassportType: MdsLax<InstanceType<typeof Edit>>;
    input_RefPassportIssuedCountry2: MdsLax<InstanceType<typeof Edit>>;
    input_RefPassportValidFrom: MdsLax<InstanceType<typeof DateInput>>;
    input_RefPassportValidUntil: MdsLax<InstanceType<typeof DateInput>>;


    isValid(): boolean {
        if (!this.input_PersonalDocNumber.isValid) return false;
        if ((this.className == "passport" || this.className == "visa") && !this.input_ValidUntil.isValid) return false;
        if ((this.className == "train_bonus_card" || this.className == "frequent_flier_card") && !this.input_DateMonthYear.isValid) return false;

        return true;
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        let entity = this.getAttributeValue("ref_passport");
        if (entity) this.fillReadOnlyFields(entity);
    }

    adjustInputsForDocumentClass() {

        let nodeList = dojoQuery("[data-document-type]", this.domNode);
        
        nodeList.forEach((node) => {
            let documentType: String = this.UiModder.domAttr.getNodeProp(node, "data-document-type");

            if (documentType.indexOf(this.className) === -1) {

                let parentNode = node.parentNode;

                this.UiModder.domConstruct.destroy(node);

                let count = 0;
                parentNode.childNodes.forEach((n) => { if (n.nodeName == "DIV") count++; });

                if (count === 0) this.UiModder.domClass.add(parentNode, "w3-hide");
            }
        })
    }

    private fillReadOnlyFields(entity) {

        this.input_PassportType.setValue(entity?.ref_vt_personal_document_type?.description, true);
        this.input_RefPassportIssuedCountry2.setValue(entity?.ref_issued_country2?.description, true);
        this.input_RefPassportValidFrom.setValue(entity?.date_valid_from, true);
        this.input_RefPassportValidUntil.setValue(entity?.date_valid_until, true);
    }

    private _onChangeInPassport() {
        
        let entity = this.input_InPassport.getValue(true);

        this.fillReadOnlyFields(entity);
    }
    private _onChangeOwner2() {

    }
    private _onClick_OpenSED(identifierName, evt) {

        this.loadSelectEntityDialog(evt,
            identifierName,
            lang.hitch(this, this._onCallback_Dlg)
        );
    }
    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<any>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;
        let entity = null;

        switch (mode) {
            case "selectOwner2":

                entity = {
                    ID: items[0].entry.value, gDisp_Firstname_Name: items[0].entry.label
                }

                this.input_Owner2.setValue(entity)
                break;
        }
    }
    private _setInputsLabel() {

        switch (this.className) {
            case "passport":
                this.input_PersonalDocNumber.setLabel(this.translate("General_Label_PassportNumber"));
                this.input_IssuedAuthority.setLabel(this.translate("General_Label_IssuedAuthority"));
                break;
            case "train_bonus_card":
            case "frequent_flier_card":
                this.input_PersonalDocNumber.setLabel(this.translate("General_Label_CardNumber"));
                this.input_IssuedAuthority.setLabel(this.translate("General_Label_IssuedAuthority_Cards"));
                break;
            case "visa":
                this.input_PersonalDocNumber.setLabel(this.translate("General_Label_VisaNumber"));
                this.input_IssuedAuthority.setLabel(this.translate("General_Label_IssuedAuthority"));
                break;
            default:
                this.input_PersonalDocNumber.setLabel(this.translate("General_Label_DocumentNumber"));

        }
    }
    setClassName(className: string) {

        this.className = className;
        this._setInputsLabel();
        this.loadDocumentTypeList();
    }
    setAddressId(addressId: string) {

        this.addressId = addressId;
        this.loadRefPassportDocumentTypeList();
    }
    loadDocumentTypeList() {

        this.input_DocumentType.setCallfunction("Webtool_API_AddressWizard_AddressDocuments_GetSearchSelectListValues");
        this.input_DocumentType.setRequestParameter("mode", "DocumentType");
        this.input_DocumentType.setRequestParameter("Classname", this.className);
        this.input_DocumentType.loadListValues();
    }
    loadRefPassportDocumentTypeList() {
        if (this.input_InPassport) {
            this.input_InPassport.setCallfunction("Webtool_API_AddressWizard_AddressDocuments_GetSearchSelectListValues");
            this.input_InPassport.setRequestParameter("mode", "InPassport");
            this.input_InPassport.setRequestParameter("addressId", this.addressId);
            this.input_InPassport.loadListValues();
        }
    }

    //private _onChanged_ValidUntilMonthYear() {

    //    let date: Date = this.getAttributeValue("date_valid_until_month_year");
    //    if (!date) return;
    //    date.setDate(1);
    //    this.setAttributeValue("date_valid_until_month_year", date);
    //}
    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (navigator.userAgent.indexOf("Firefox") != -1 ) {

            this.input_DateMonthYear.setLabel(`${this.translate("General__ValidUntil")} (JJJJ-MM)`);
        }
    //    this.addOnchanged("date_valid_until_month_year", lang.hitch(this, this._onChanged_ValidUntilMonthYear));
    //    let tooltip = new Tooltip();
    //    tooltip.setup({
    //        content: this.translations["AddressDocuments_Tooltip_ValidUntilMonthYear"],
    //        targetnode: this.input_DateMonthYear.domNode,
    //        enableHover: true,
    //        delayMS: 500
    //    });
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.input_AddressDocumentStatus.setCallfunction("Webtool_API_AddressWizard_AddressDocuments_GetSearchSelectListValues");
        this.input_AddressDocumentStatus.setRequestParameter("mode", "AddressDocumentStatus");
        this.input_AddressDocumentStatus.loadListValues();

        if (this.input_IssuedCountry) {

            this.input_IssuedCountry.setCallfunction("Webtool_API_AddressWizard_AddressDocuments_GetSearchSelectListValues");
            this.input_IssuedCountry.setRequestParameter("mode", "Country");
            this.input_IssuedCountry.loadListValues();
        }
        if (this.input_IssuedCountry2) {
            this.input_IssuedCountry2.setCallfunction("Webtool_API_AddressWizard_AddressDocuments_GetSearchSelectListValues");
            this.input_IssuedCountry2.setRequestParameter("mode", "Country");
            this.input_IssuedCountry2.loadListValues();
        }
        if (this.input_Owner2) {
            this.input_Owner2.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectOwner2"));
            this.SEDconfigCallfunction = "Webtool_API_AddressWizard_AddressDocuments_SED_GetConfig";
        }
    }
}

export default mdsWidget(DocumentsEditorForm);